import apiRequest from "../../helpers/apiRequest";

export default async (tutor) => {
    return await apiRequest({
        method: 'get',
        url: `content/booked/slots/${tutor}`,
    })
}
